import React, { useEffect } from "react"
import { Button } from "reactstrap"
import { useToasts } from "react-toast-notifications"
import useXlsxDownload from "../../../Logistics/useXlsxDownload"

export const GAME_SHEETS_FAILED = "The game sheets could not be downloaded. Try again."
// The gateway route both the CP and SportyaOS download the sheets from (P54): the PDF, or the same sheets as a workbook.
export const gameSheetsUrl = (eventId, competitionId, format = "pdf") =>
  `/exports/events/${eventId}/competitions/${competitionId}/game-sheets${format === "xlsx" ? "?format=xlsx" : ""}`

// A Tenis10 competition's game sheets (Tudor 2026-10-25, canvas P54 CP-A): its groups and its knockout bracket with the results entered so
// far, in the language of the event's country. „Game sheets (XLS)” takes the place of „Generate Main Draw .XLS”, „Game sheets (PDF)” follows it.
export default function GameSheetsButtons({ eventId, competitionId, disabled = false, className = "" }) {
  const { addToast } = useToasts()
  const xlsx = useXlsxDownload(GAME_SHEETS_FAILED)
  const pdf = useXlsxDownload(GAME_SHEETS_FAILED)
  const failure = xlsx.error || pdf.error
  useEffect(() => {
    if (!failure) return
    addToast(failure, { appearance: "error", autoDismiss: true })
    xlsx.dismiss()
    pdf.dismiss()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [failure])
  const busy = xlsx.busy || pdf.busy
  return (
    <>
      <Button
        className={`game-sheets-export ${className}`.trim()}
        color="primary"
        disabled={disabled || busy}
        onClick={() => xlsx.download(gameSheetsUrl(eventId, competitionId, "xlsx"), {}, "game-sheets.xlsx")}
      >
        {xlsx.busy ? "Generating .XLS..." : "Game sheets (XLS)"}
      </Button>
      <Button
        className={`game-sheets-export ${className}`.trim()}
        color="primary"
        disabled={disabled || busy}
        onClick={() => pdf.download(gameSheetsUrl(eventId, competitionId), {}, "game-sheets.pdf")}
      >
        {pdf.busy ? "Generating PDF..." : "Game sheets (PDF)"}
      </Button>
    </>
  )
}
